import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { FaMapPin, FaRegStar, FaStar } from "react-icons/fa";
import { RiPushpin2Fill, RiPushpinFill } from "react-icons/ri";
import { GetAllEventsOutput } from "~/types/EventTypesInferred";
import { cn } from "~/utils/fontsConfig";

const pinVariants = cva(
    `
      right-0 z-30 flex
      items-center justify-center rounded border-v2-primary
      leading-none text-white shadow-xl
    `,
    {
        variants: {
            size: {
                default: "h-8  w-full max-w-max px-4 py-1 ",
                small: "absolute h-5 w-5 top-1 right-1  ",
            },
        },
        defaultVariants: {
            size: "default",
        },
    },
);

const iconSize = {
    default: "",
    small: "w-3 h-2",
};

interface PinnedTagProps extends VariantProps<typeof pinVariants> {
    event: GetAllEventsOutput;
}

const PinnedTag = ({ event, size }: PinnedTagProps) => {
    if (!event.pinnedCommunityEvents.length) {
        return null;
    }

    return (
        <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-v3-N-450 bg-opacity-80 p-1 md:h-8 md:w-8">
            <RiPushpin2Fill className="h-4 w-4 md:h-5 md:w-5" />
        </span>
    );
};

export default PinnedTag;
